module.exports = __webpack_public_path__ + "static/media/hidden-company-4.55356e27.svg";